import TagManager from 'react-gtm-module';

let initialized = false;

// Support both Vite and CRA env vars
const ENV_GTM_ID = (import.meta as any)?.env?.VITE_GTM_ID;

export function initGtm(id?: string) {
  const gtmId = id || ENV_GTM_ID;
  if (!gtmId || initialized) return;

  TagManager.initialize({
    gtmId,
    // You can pre-seed the dataLayer if needed:
    // dataLayer: { app: 'chubb-cyber-index' },
  });
  initialized = true;
}

export function pushDL(data: Record<string, any>) {
  TagManager.dataLayer({ dataLayer: data });
}

// Convenience helpers
export const gtm = {
  formEvent: (label: string, formName?: string) => pushDL({ event: 'formEvent', label, formName }),
  formStep: (
    formName?: string,
    formStepName?: string,
    formStepNumber?: number,
    formComplete?: boolean,
    formData?: any
  ) => pushDL({ event: 'formStep', formName, formStepName, formStepNumber, formComplete, formData }),
  selection: (field: string, value: string, formName?: string) =>
    gtm.formEvent(`Selected: ${field}: ${value}`, formName),
  clearSelection: (field: string, formName?: string) =>
    gtm.formEvent(`Cleared Selection: ${field}`, formName),
  pageview: (path: string, title?: string) => pushDL({ event: 'pageview', page_path: path, page_title: title }),
  chartInteraction: (eventCategory: string, eventName: string) => pushDL({ event: 'chartEvent', eventCategory, eventName })
};